export default {
	到: 'へ',
	登录: 'ログイン',
	第三方登录: '外部サービスでログイン',
	点击登录: 'ログインへ',
	点击注册: '登録へ',
	记住我: 'ログイン状態を保持',
	距离完成注册仅剩下最后一步: '登録完了まであと一歩です！',
	没有账号: 'アカウントをお持ちでない方',
	设置密码: 'パスワード設定',
	完成注册: '登録を完了',
	'忘记密码?': 'パスワードをお忘れですか？',
	修改密码: 'パスワード変更',
	验证码: '認証コード',
	已有账号: 'すでにアカウントをお持ちの方',
	重新发送: '再送信',
	注册: '登録',
	注册验证码: '登録用認証コード',
	重置密码: 'パスワードをリセット',
	重置密码成功: 'パスワードのリセットに成功しました',
	重置密码成功提示: '新しいパスワードを保管し、新しいパスワードでログインしてください。',
}
